module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__bice_White.f6a58c9d.svg";